

import React, {Component} from 'react'
import { connect } from 'react-redux'

var constants = require('../../../../utils/domain/constants.js');
var saleCommonUtility = require('../../../../utils/domain/sales/saleCommonUtility.js');

const translator = require('../../../../utils/translator/translator.js');

class Header extends Component 
{
    render()
    {

        var sale = this.props.saleContext.sale;
        var number = sale.number;
        if (number == null)
            number = "N/A";

        var venueCode = sale.venueCode;
        if (venueCode == constants.VenueCodeProperty)
            venueCode = "Store";

        var caption = `${venueCode} / ${sale.dispatchType}`

        let backGroundColor = 'var(--colors-primary)';
        if (saleCommonUtility.isSaleHoldByStaff(sale))
            backGroundColor = '#C41E3A';

        return <div style={{background:backGroundColor, padding:'5px', border:`1px solid ${backGroundColor}`, borderRadius:5}}>
                    <table width="100%">
                        <tr style={{color:'#F0F0F0'}}>
                            <td  style={{ whiteSpace: "nowrap" }}>
                                <div style={{marginLeft: '5px', marginRight:'5px'}}>{caption}</div>
                            </td>
                        </tr>
                        <tr style={{color:'#F0F0F0'}}>
                            <td style={{ whiteSpace: "nowrap" }}>
                                <div style={{marginLeft: '5px', marginRight:'5px'}}>{translator.getLabel("number")}: {number}</div>
                            </td>
                        </tr>
                    </table>
                </div>
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(Header)